
import * as GuidModule from '@ms/utilities-guid/lib/Guid';

type Guid = {};
const Guid = GuidModule;

export default Guid;
